// extracted by mini-css-extract-plugin
export default {"editor":"send-messages_editor__0f7dM"};